export const environment = {
  production: false,
  apiUrl: 'https://arcapitest.cyberland.sg/api',
  LATEST_VERSION: '1.1.0',
};
